import type { ReactNode } from "react";

import { COLORS } from "@busright/ui";

export interface MeterBarProps {
  readonly label: string;
  // Fraction filled, 0–1.
  readonly fraction: number;
  // Right-hand readout (already formatted).
  readonly valueText: string;
}

// A neutral horizontal meter (brand accent fill — NOT RAG). Used for non-health/non-risk ratios
// such as credit-limit utilization, where the color law forbids RAG red/amber/green.
export const MeterBar = ({ label, fraction, valueText }: MeterBarProps): ReactNode => {
  const pct = Math.max(0, Math.min(100, fraction * 100));
  return (
    <div className="bullet">
      <span className="bullet-label">{label}</span>
      <div className="bullet-track">
        <div className="bullet-fill" style={{ width: `${pct}%`, background: COLORS.accent }} />
      </div>
      <span className="bullet-value br-tabular-nums">{valueText}</span>
    </div>
  );
};
